<template>
  <v-chip
    color="warning"
    text-color="white"
    disabled
    small
  >Fee account</v-chip>
</template>

<script>
  export default {
    name: 'FeeAccountLabel'
  }
</script>
